import {defineSlotRecipe} from '@chakra-ui/react3'

export const breadcrumbRecipe = defineSlotRecipe({
    slots: ['scrollContainer', 'overflowButton', 'overflowFade', 'wrapper'],
    base: {
        scrollContainer: {
            width: '100vw',
            maxWidth:
                'calc(var(--leap-sizes-container-page-max-width) + 2 * var(--leap-spacing-spacing-92))',
            marginInline: 'auto',
            overflowX: 'auto',
            scrollbarWidth: 'none'
        },
        overflowButton: {
            cursor: 'pointer',
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            height: 14,
            _after: {
                content: '"…"',
                userSelect: 'none'
            }
        },
        overflowFade: {
            position: 'absolute',
            right: 0,
            height: 14,
            width: '2.125rem',
            background: `linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, var(--bg-currentcolor, #FFF) 88%)`
        },
        wrapper: {
            minWidth: 'xs',
            maxWidth: 'full',
            width: 'full',
            px: {base: 'spacing-20', xs: 'spacing-49', s: 'spacing-92'},
            py: 'spacing-12',
            marginInline: 'auto'
        }
    },
    variants: {
        variant: {
            sunset: {
                scrollContainer: {
                    maxWidth: 'min(100%, {sizes.container-page-max-width})',
                    margin: {base: 0, '2xl': 'auto'}
                },
                wrapper: {
                    maxWidth: 'container.xxl',
                    px: {base: 'spacing-20', xs: 'spacing-48', s: 'spacing-90'}
                }
            }
        }
    }
})
